import Vue from "vue";
import VueRouter from 'vue-router'
// 使用插件
Vue.use(VueRouter)

// 引入路由组件
import Journalism from '@/pages/Journalism'
import Product from '@/pages/Product'
import Order from '@/pages/Order'
import Contact from '@/pages/Contact'
import Personal from '@/pages/Personal'
import Login from '@/pages/Login'
import PwdChange from '@/pages/PwdChange'
import User from '@/pages/Personal/User'
import Billing from '@/pages/Personal/Billing'
import Goods from '@/pages/Personal/Goods'
import Purchase from '@/pages/Purchase'
import orderPay from '@/pages/orderPay'
import Inventory from '@/pages/Inventory'
import Issue from '@/pages/Issue'
import sunmitOrder from '@/pages/submitOrder'
import Physical from '@/pages/Physical'
import J_details from '@/pages/J_details'

let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace

// 重写push|replace
VueRouter.prototype.push = function (location, resolve, reject) {
	if (resolve && reject) {
		originPush.call(this, location, resolve, reject)
	} else {
		originPush.call(this, location, () => { }, () => { })
	}
}
VueRouter.prototype.replace = function (location, resolve, reject) {
	if (resolve && reject) {
		originReplace.call(this, location, resolve, reject)
	} else {
		originReplace.call(this, location, () => { }, () => { })
	}
}

// 普通路由
export const ordinaryRouter = [{
	path: '*',
	redirect: '/login'
},
{
	path: '/journalism',
	component: Journalism,
	meta: {
		show: true
	}
},
{
	path: '/j_details',
	component: J_details,
	meta: {
		show: true
	}
},
{
	path: '/product',
	component: Product,
	meta: {
		show: true
	}
},
{
	path: '/order',
	component: Order,
	meta: {
		show: true
	},
},
{
	path: '/contact',
	component: Contact,
	meta: {
		show: true
	}
},
{
	path: '/personal',
	component: Personal,
	meta: {
		show: true
	},
	redirect: '/personal/userinfo',
	children: [{
		path: 'userinfo',
		component: User,
		meta: {
			show: true
		},
	},
	{
		path: 'billinginfo',
		component: Billing,
		meta: {
			show: true
		},
	},
	{
		path: 'goodsinfo',
		component: Goods,
		meta: {
			show: true
		},
	}
	]
},
{
	path: '/login',
	component: Login,
	meta: {
		show: false
	}
},
{
	path: '/pwdchange',
	component: PwdChange,
	meta: {
		show: true
	}
},
{
	path: '/purchase',
	component: Purchase,
	meta: {
		show: true
	}
},
{
	path: '/inventory',
	component: Inventory,
	meta: {
		show: true
	}
},
{
	path: '/physical',
	component: Physical,
	meta: {
		show: true
	}
}
]

// 权限路由
export const orderRouter = [{
	path: '/orderpay',
	component: orderPay,
	meta: {
		show: true
	}
},]
export const issueRouter = [{
	path: '/issue',
	component: Issue,
	meta: {
		show: true
	}
}]

export const sunmitOrderRouter = [{
	path: '/sunmitorder',
	component: sunmitOrder,
	meta: {
		show: true
	}
}]

// 配置路由
let router = new VueRouter({
	routes: ordinaryRouter,
	mode: 'history'
})

// 路由守卫
router.beforeEach((to, from, next) => {
	if (sessionStorage.getItem('token')) {
		if (to.path === '/login') {
			next('/journalism');
		} else {
			next();
		}
	} else {
		if (to.path === '/login') {
			next();
		} else {
			next('/journalism');
		}
	}
})

export default router
